export default "__VITE_ASSET__CmooKB5R__"